document.addEventListener('DOMContentLoaded', function() {
    const articleDate = document.querySelector('.article-title-with-date');
    const articleImage = document.querySelector('.article-template__block--image');
  const newDiv = document.createElement('div');
  newDiv.classList.add('article-feature-title-container');
  newDiv.classList.add('page-width');

if (articleDate && articleImage) {
  newDiv.appendChild(articleDate); // pass the element, not a string
  newDiv.appendChild(articleImage); // pass the element, not a string

}


  // Set display: flex
  newDiv.style.display = 'flex';


  const articleContainer = document.querySelector('article'); // adjust selector if needed
  if (articleContainer) {
    articleContainer.insertBefore(newDiv, articleContainer.firstChild);
  }
});
